import { useTranslation } from "react-i18next";
import { useStorageObject } from "../../app/state/storageObjectSlice/hook/use-storage-object";
import { useServiceNavigate } from "../../app/state/storageObjectSlice/hook/use-service-navigate";
import { Sidebar } from "../../common/AppSidebar";
import { SafeOutlet } from "../../common/Protectors/SafeOutlet";
import styles from "./styles.module.css";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";

export const MeetingsPage = () => {
  const { menuItems, selectedObject, isLoading, currentService } =
    useStorageSelectors("meetings");
  const { addObject, handleSelectObject } = useStorageObject(
    "meetings",
    "meetings",
    currentService,
  );
  const { t } = useTranslation();

  useServiceNavigate("meetings", "meetings");

  return (
    <div className={styles["page-layout"]}>
      <Sidebar
        menuItems={menuItems}
        onAdd={() => addObject(t("meetings.default_name"), "child")}
        onSelect={handleSelectObject}
        selectedId={selectedObject?.id ?? ""}
        service={"meetings"}
        isLoading={isLoading ?? false}
      />
      {selectedObject && <SafeOutlet />}
    </div>
  );
};
